var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    {
      staticClass: "vs-component con-vs-radio",
      class: [
        `vs-radio-${_vm.color}`,
        _vm.isChecked ? `${_vm.selectedClass}` : "",
      ],
    },
    [
      _c(
        "input",
        _vm._g(
          _vm._b(
            {
              staticClass: "vs-radio--input",
              attrs: { name: _vm.vsName || _vm.value, type: "radio" },
              domProps: { checked: _vm.isChecked, value: _vm.value },
            },
            "input",
            _vm.$attrs,
            false
          ),
          _vm.listeners
        )
      ),
      _vm._v(" "),
      _c("span", { staticClass: "vs-radio" }, [
        _c("span", { staticClass: "vs-radio--borde", style: _vm.styles }),
        _vm._v(" "),
        _c("span", { staticClass: "vs-radio--circle", style: _vm.styleCircle }),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "vs-radio--label" }, [_vm._t("default")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }